<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="editStatrgyArticleDialog"
  >
    <statrgy-article-form
      ref="outform"
      @submit="submit"
    ></statrgy-article-form>
  </sliderBarDialogShell>
</template>

<script>
import statrgyArticleForm from "@/components/wx/strategyArticle/statrgyArticleForm";
import {updateArticle} from "@/api/wx/strategyActicle";

export default {
  name: "editStatrgyArticleDialog",
  components: {
    statrgyArticleForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    formData:{
      type: Object,
      default(){
        return {}
      }
    }
  },
  watch:{
    dialogShow(val){
      if(val && this.formData.id){
        setTimeout(()=> {
          this.$refs.outform.assigen(this.formData);
        },200);
      }
    }
  },
  data() {
    return {
      title: '编辑'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        id: form.id,
        'strategyId': form.strategyId,
        'contentType': form.contentType,
        'content': form.content,
      }
      updateArticle(params).then((data) => {
        if(data && data.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$emit('edit-success');
          this.$refs.outform.selfClear();
        }else{
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .editStatrgyArticleDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
